import React from 'react'
import PerfilLab from '../../components/PerfilOxetechLab'

function DashLab() {
  return <div>{<PerfilLab />} </div>
}

export default DashLab
